var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          class: {
            "zero-margin-bottom": _vm.zeroMarginBottom,
            "align-left": _vm.alignLeft,
            "width-50": _vm.width50,
            "width-25": _vm.width25,
            "inline-Block": _vm.inlineBlock,
            "tooltip-width": _vm.tooltip
          },
          attrs: {
            label: _vm.label,
            "label-for": _vm.id,
            description: _vm.description
          }
        },
        [
          !_vm.hasAppendSlot
            ? _c(
                "b-form-input",
                _vm._b(
                  {
                    class: { "border-none": _vm.borderNone },
                    attrs: {
                      type: _vm.type,
                      id: _vm.id,
                      maxlength: _vm.maxlength,
                      placeholder: _vm.placeholder,
                      readonly: _vm.readonly,
                      autocomplete: _vm.autocomplete,
                      state: _vm.state,
                      size: _vm.size,
                      min: _vm.min,
                      max: _vm.max,
                      disabled: _vm.disabled,
                      step: _vm.step
                    },
                    on: {
                      keyup: function($event) {
                        return _vm.$emit("keyup", $event)
                      },
                      click: function($event) {
                        return _vm.$emit("click", $event)
                      },
                      blur: function($event) {
                        return _vm.$emit("blur", $event)
                      },
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        _vm.enterEventAction ? _vm.enterEventAction() : null
                      }
                    },
                    model: {
                      value: _vm.localValue,
                      callback: function($$v) {
                        _vm.localValue = $$v
                      },
                      expression: "localValue"
                    }
                  },
                  "b-form-input",
                  _vm.dataAttributes,
                  false
                )
              )
            : _c(
                "b-input-group",
                [
                  _c(
                    "b-form-input",
                    _vm._b(
                      {
                        class: { "border-none": _vm.borderNone },
                        attrs: {
                          type: _vm.type,
                          id: _vm.id,
                          placeholder: _vm.placeholder,
                          maxlength: _vm.maxlength,
                          readonly: _vm.readonly,
                          state: _vm.state,
                          autocomplete: _vm.autocomplete,
                          size: _vm.size,
                          min: _vm.min,
                          max: _vm.max,
                          disabled: _vm.disabled,
                          step: _vm.step
                        },
                        on: {
                          keyup: function($event) {
                            return _vm.$emit("keyup", $event)
                          },
                          keydown: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            _vm.enterEventAction ? _vm.enterEventAction() : null
                          }
                        },
                        model: {
                          value: _vm.localValue,
                          callback: function($$v) {
                            _vm.localValue = $$v
                          },
                          expression: "localValue"
                        }
                      },
                      "b-form-input",
                      _vm.dataAttributes,
                      false
                    )
                  ),
                  _vm._v(" "),
                  _vm.hasAppendSlot
                    ? _c(
                        "b-input-group-append",
                        [_c("b-input-group-text", [_vm._t("append")], 2)],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("vuelidate-error", {
                    attrs: {
                      state: _vm.state,
                      validator: _vm.validator,
                      requiredErrorMsg: _vm.requiredErrorMsg
                    }
                  })
                ],
                1
              )
        ],
        1
      ),
      _vm._v(" "),
      _vm.tooltip
        ? _c("b-icon-question-circle", {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.hover",
                modifiers: { hover: true }
              },
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.click",
                value: _vm.tooltip,
                expression: "tooltip",
                modifiers: { click: true }
              }
            ],
            attrs: { title: _vm.tooltip }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.inputInfoText
        ? _c("b-form-text", [_vm._v(_vm._s(_vm.inputInfoText))])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ac300cb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ac300cb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/forms/BaseInput.vue
// module id = 1639
// module chunks = 116